import { C, fonts } from "../theme.js";
import { ClippedBtn, Pill } from "./primitives.jsx";
import { ParticleWave } from "./ParticleWave.jsx";

export const Hero = ({ accent }) => (
  <section
    style={{
      position: "relative",
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      overflow: "hidden",
      background: C.bg,
    }}
  >
    <ParticleWave accent={accent} density={1} amplitude={1} speed={1} />
    <div
      style={{
        position: "absolute",
        inset: 0,
        background:
          "radial-gradient(ellipse at center, rgba(10,10,10,0) 0%, rgba(10,10,10,0.55) 55%, rgba(10,10,10,0.92) 90%)",
        pointerEvents: "none",
      }}
    />
    <div
      style={{
        position: "relative",
        zIndex: 2,
        maxWidth: 980,
        padding: "0 32px",
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 30,
      }}
    >
      <Pill accent={accent}>TAKING ON NEW CLIENTS</Pill>
      <h1
        style={{
          fontFamily: fonts.serif,
          fontWeight: 500,
          fontSize: "clamp(40px, 6.4vw, 84px)",
          lineHeight: 1.04,
          color: C.fg,
          margin: 0,
          letterSpacing: "-0.01em",
          textWrap: "balance",
        }}
      >
        We build the AI infrastructure your business{" "}
        <em style={{ color: accent, fontStyle: "italic", fontWeight: 500 }}>runs on.</em>
      </h1>
      <p
        style={{
          fontFamily: fonts.mono,
          fontSize: 14,
          lineHeight: 1.7,
          color: C.body,
          maxWidth: 640,
          margin: 0,
          letterSpacing: "0.01em",
        }}
      >
        From data pipelines to production LLMs — we engineer systems that scale, perform, and deliver real results.
      </p>
      <div style={{ display: "flex", gap: 14, flexWrap: "wrap", justifyContent: "center", marginTop: 6 }}>
        <ClippedBtn filled big accent={accent} href="#contact">WORK WITH US ↗</ClippedBtn>
        <ClippedBtn big accent={accent} href="#services">OUR SERVICES</ClippedBtn>
      </div>
    </div>
    <div
      style={{
        position: "absolute",
        right: 32,
        bottom: 28,
        fontFamily: fonts.mono,
        fontSize: 10,
        letterSpacing: "0.2em",
        color: C.faint,
        zIndex: 2,
      }}
    >
      SCROLL ↓
    </div>
  </section>
);
